import * as React from "react";
import { DOCUMENT_TYPE } from "../const";

export const DocumentGridTemplate = ({cell}) => {
    return (
        <div style={{ whiteSpace: "normal" }}>
            {DOCUMENT_TYPE[cell]}
        </div>
    );
};
